import { ProductListItemUI } from './ProductListItemUI'
import { useProductListItem } from './useProductListItem'

interface ProductListItemProps {
  product: any
  className?: string
  variant?: 'grid' | 'list'
  isLargeCard?: boolean
  // Compra Recorrente (007): selo vindo de useRecurrencyBadges na listagem
  recurrencyState?: 'available' | 'unavailable'
}

export const ProductListItem = ({ product, variant, isLargeCard, recurrencyState }: ProductListItemProps) => {
  const productListItemProps = useProductListItem({ product })

  return (
    <ProductListItemUI
      product={product}
      {...productListItemProps}
      variant={variant}
      isLargeCard={isLargeCard}
      recurrencyState={recurrencyState}
    />
  )
}
